import { ApplicationSelect } from '@frontend/functionality/select';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useApplicationConstraintDataInput from './application-constraint-data-input.controller';

const ID = 'application-constraint-data-input';
export interface ApplicationConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const ApplicationConstraintDataInput = (props: ApplicationConstraintDataInputProps) => {
    const viewProps = useApplicationConstraintDataInput(props);

    return (
        <div
            id={ID}
            className='flex w-full'>
            <ApplicationSelect
                required
                value={viewProps.formValues?.application ?? null}
                onSelect={(v) => {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { application: v.value } : undefined }));
                }}
            />
        </div>
    );
};

export default ApplicationConstraintDataInput;
